/**
 * form-request-reskin — Home pending-forms alert (count-keyed).
 *
 * Ported VERBATIM from the confirmed mockup
 * docs/mockups/client-dashboard-redesign/form-request-flow.html
 *   variant A (single doorbell) :777 · grouped card :820.
 * Substitutes the injected theme tokens for the mockup's literal hexes; static
 * design constants (radii, icon boxes, px sizes) are copied as-is. Radius/font
 * tokens carry fallbacks so the component is self-contained outside `.page`.
 */

/* Variant A — full "doorbell" card (rhymes with profile-tab .form-action). */
.alertCard {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin-bottom: 14px;
  padding: 12px 13px;
  border: 0;
  cursor: pointer;
  border-radius: var(--r-md, 14px);
  background: var(--glass-bg-strong, rgba(24, 22, 20, 0.72));
  backdrop-filter: var(--glass-blur, blur(20px));
  box-shadow: var(--glass-shadow, 0 8px 24px rgba(0, 0, 0, 0.45));
  overflow: hidden;
  text-align: left;
}
.alertCard > * {
  position: relative;
  z-index: 1;
}
/* The Home cards' 1px ring (BookingHubPage .nextSession::before), accent per D10. */
.alertCard::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 1px;
  background: var(--booking-card-ring-bg);
  -webkit-mask: linear-gradient(black 0 0) content-box, linear-gradient(black 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
  z-index: 2;
}

.ico {
  width: 38px;
  height: 38px;
  border-radius: 11px;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  background: rgba(var(--accent-rgb), 0.16);
  border: 1px solid rgba(var(--accent-rgb), 0.3);
  color: var(--accent-hot);
}
.ico svg {
  width: 18px;
  height: 18px;
  stroke-width: 1.8;
}

.main {
  flex: 1;
  min-width: 0;
}
.kicker {
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--accent);
  margin-bottom: 2px;
}
.name {
  font-family: var(--font-display, 'EB Garamond', Georgia, serif);
  font-weight: 500;
  font-size: 15.5px;
  letter-spacing: -0.012em;
  color: var(--text-primary);
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.meta {
  font-size: 11px;
  color: var(--text-tertiary);
  margin-top: 2px;
}
.cta {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--accent-hot);
}
.cta svg {
  width: 15px;
  height: 15px;
  stroke-width: 2.2;
}

/* Grouped card for exactly 2 pending. */
.group {
  flex-direction: column;
  align-items: stretch;
  gap: 0;
  padding: 0;
  cursor: default;
}
.groupHead {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 13px 9px;
}
.groupHead .kicker {
  margin-bottom: 0;
}
.groupCount {
  min-width: 17px;
  height: 17px;
  padding: 0 5px;
  border-radius: var(--r-pill, 9999px);
  background: rgba(var(--accent-rgb), 0.18);
  box-shadow: inset 0 0 0 1px rgba(var(--accent-rgb), 0.4);
  color: var(--accent-hot);
  font-size: 10px;
  font-weight: 700;
  display: grid;
  place-items: center;
}
.row {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 10px 13px;
  border: 0;
  border-top: 1px solid var(--border-subtle);
  background: transparent;
  cursor: pointer;
  text-align: left;
  width: 100%;
}
.row:first-of-type {
  border-top-color: transparent;
}
.row .ico {
  width: 32px;
  height: 32px;
  border-radius: 9px;
}
.row .ico svg {
  width: 15px;
  height: 15px;
}

/* 3+ summary: the tappable body of the folded card; the card opens in place. */
.summary {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 13px;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
/* Show less, in the opened card's head. */
.less {
  margin-left: auto;
  padding: 0;
  border: 0;
  background: transparent;
  font-family: inherit;
  cursor: pointer;
}
